import React from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";
import { MdLanguage } from "react-icons/md";
import { SUPPORTED_LANGUAGES } from "../../i18n";

const LanguagePicker = () => {
  const { i18n, t } = useTranslation();

  // i18n.language may be a regional variant (e.g. "es-MX"); normalize to the
  // base code so the active language is highlighted correctly.
  const activeCode = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];

  const changeLanguage = (code) => {
    // Persists to localStorage via the detector's cache config.
    i18n.changeLanguage(code);
  };

  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        variant="outline-secondary"
        size="sm"
        id="language-picker"
        aria-label={t("common.language")}
      >
        <MdLanguage className="me-1" />
        {(SUPPORTED_LANGUAGES.find((l) => l.code === activeCode) || SUPPORTED_LANGUAGES[0]).label}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {SUPPORTED_LANGUAGES.map((lang) => (
          <Dropdown.Item
            key={lang.code}
            active={lang.code === activeCode}
            onClick={() => changeLanguage(lang.code)}
          >
            {lang.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguagePicker;
